import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, type PropType } from 'vue';

import { syncWithStorage } from '@exchange/helpers/persistance-helper';
import useTradingMobileRoutes from '@exchange/libs/composables/shared/src/lib/useTradingMobileRoutes';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

import MarketList from './components/MarketList.vue';
import MarketListFilters from './components/MarketListFilters.vue';
import useMarketListFilters from './useMarketListFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketsContainer',
  props: {
  searchInFocus: { type: Boolean, default: false },
  variant: { type: String as PropType<'dark-medium' | 'default'>, default: 'default' },
  withLogo: { type: Boolean, default: false },
  marketId: { type: String, default: () => syncWithStorage(CONSTANTS.SELECTED_MARKET, CONSTANTS.DEFAULT_MARKET_ID) },
  isFutures: { type: Boolean, default: false },
},
  emits: ["market-clicked"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

useTradingMobileRoutes(props.isFutures ? { name: 'futures', params: { marketId: props.marketId } } : { name: 'exchange' });

const { filteredMarketList, isFavorite, updateFavorite, marketDataLoading, applyMarketFilters, activeCurrencyFilter, marketTypeFilter } = useMarketListFilters();

applyMarketFilters({});

const search = ref<string>();

const onSearchCallback = (searchString?: string) => applyMarketFilters({ search: searchString });
const onMarketTypeFilterSelected = (marketTypeFilterArg?: string) => applyMarketFilters({ marketTypeFilter: marketTypeFilterArg });

return (_ctx: any,_cache: any) => {
  const _component_ot_search = _resolveComponent("ot-search")!
  const _component_ot_module_container = _resolveComponent("ot-module-container")!

  return (_openBlock(), _createBlock(_component_ot_module_container, {
    class: _normalizeClass(["markets-container", [`markets-container--${__props.variant}`]]),
    "log-name": "markets",
    variant: "default",
    "with-bottom-padding": true,
    loading: _unref(marketDataLoading)
  }, {
    default: _withCtx(({ sectionClass }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["markets-container__search", sectionClass])
      }, [
        _createVNode(_component_ot_search, {
          value: search.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          variant: "dark",
          autofocus: false,
          "on-search-cb": onSearchCallback
        }, null, 8, ["value"])
      ], 2)
    ]),
    "header-left-actions": _withCtx(() => [
      _createVNode(MarketListFilters, {
        class: "markets-container__filters",
        "active-market-type-filter": _unref(marketTypeFilter),
        variant: __props.variant,
        onMarketTypeFilterSelected: onMarketTypeFilterSelected
      }, null, 8, ["active-market-type-filter", "variant"])
    ]),
    "main-content": _withCtx(() => [
      (!_unref(marketDataLoading))
        ? (_openBlock(), _createBlock(MarketList, {
            key: 0,
            class: "markets-container__list",
            "filtered-by": _unref(activeCurrencyFilter),
            "is-favorite": _unref(isFavorite),
            "is-filtered-by-favorites": false,
            "market-id": __props.marketId,
            "market-list": _unref(filteredMarketList),
            "update-favorite": _unref(updateFavorite),
            "with-logo": __props.withLogo,
            "onList:marketClicked": _cache[1] || (_cache[1] = ($event: any) => (emit('market-clicked', $event)))
          }, null, 8, ["filtered-by", "is-favorite", "market-id", "market-list", "update-favorite", "with-logo"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "loading"]))
}
}

})